let storage = {
  save(key, value) {
    localStorage.setItem(key, value)
  },
  remove(key) {
    localStorage.removeItem(key)
  }
}

export default storage



// WEBPACK FOOTER //
// ./src/common/localStorage.js